export default "__VITE_ASSET__DiOfSdA6__"